import React from "react";
import styled from "styled-components";
import BaseSection from "../BaseSection";

const TextSection = styled(BaseSection)`
  & > .content {
    padding-top: 80px;
    padding-bottom: 40px;

    & > div {
      flex: 1;

      h2 {
        font-size: 3rem;
        line-height: 3rem;
        color: yellow;
        text-align: center;
      }

      h3 {
        font-size: 2rem;
        line-height: 2rem;
        color: white;
        text-align: center;
      }

      p {
        text-align: center;
        font-size: 1rem;
        line-height: 1.5rem;
        color: #ddd;
      }
    }
  }
`;

export default TextSection;
